import { useMutation, useQuery } from '@tanstack/react-query';

import { aPIPaths, requestEBank } from '../../Redux';

export interface IVerifyPayeeRequest {
  ClientName: string;
  Iban: string;
  PaymentId: string | null;
}

export enum EnumVerifyPayeeMatch {
  NOAP = 'NOAP',
  NOAP_OPT = 'NOAP.OPT',
  MTCH = 'MTCH',
  CMTC = 'CMTC',
  NMTC = 'NMTC',
}

interface IVerifyPayeeResponse {
  PartyNameMatch: EnumVerifyPayeeMatch;
  MatchedName?: string;
  RequestId: string;
  PartyIdMatch?: string;
  Details?: string;
}

const useVOP = () => {
  return useMutation({
    mutationFn: async (data: IVerifyPayeeRequest) => {
      const res = await requestEBank.post(aPIPaths.vop.postVop, data);

      return res.data as IVerifyPayeeResponse;
    },
  });
};

const useBulkStatusGET = () => {
  return useQuery({
    queryKey: ['vopBulkStatus'],
    queryFn: async () => {
      const res = await requestEBank.get(aPIPaths.vop.getBulkStatus);
      return res.data;
    },
  });
};

const useBulkStatusPOST = () => {
  return useMutation({
    mutationFn: async (status: boolean) => {
      const res = await requestEBank.post(aPIPaths.vop.postVOPBulkStatus(status));

      return res.data;
    },
  });
};

export const useApiVOP = {
  postVOP: useVOP,
  getBulkStatus: useBulkStatusGET,
  postBulkStatus: useBulkStatusPOST,
};
